import { Segmented } from 'antd';
import styled from 'styled-components';

export const StyledSegmented = styled(Segmented)`
  margin-bottom: 24px;
  border: 1px solid #dbdde2;
  &&& {
    .ant-segmented-item-label {
      min-height: 45px;
      line-height: 45px;
    }
  }
`;
